import './AdminSidebar.css';
import Nav from 'react-bootstrap/Nav';
import * as Icon from 'react-bootstrap-icons';
import {
    HashRouter as Router,
    Link,
    useRouteMatch,
} from "react-router-dom";

function AdminSidebar(){
    let match = useRouteMatch();
    return(
        <Nav className="sidebar col-md-2 col-lg-2 d-md-block bg-light collapse position-sticky pt-3 border-right" >
            <Nav defaultActiveKey="Requests" as="ul" className="flex-column align-items-center">
                <Nav.Item as="li">
                    <Link className="nav-link"  role="button" to={`${match.url}/requests`}>
                        REQUESTS&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <Icon.FileEarmarkText />
                        </Link>
                </Nav.Item>
                <Nav.Item as="li">
                    <Link className="nav-link" role="button" to={`${match.url}/warehouse`}>
                        WAREHOUSE&nbsp;&nbsp;
                        <Icon.Table />
                    </Link>
                </Nav.Item>
                <Nav.Item as="li">
                    <Link className="nav-link" role="button" to={`${match.url}/referral-partners`}>
                        PARTNERS&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <Icon.People />
                        </Link>
                </Nav.Item>
                <Nav.Item as="li">
                    <Link className="nav-link" role="button" to={`${match.url}/statistics`}>
                        CLIENTS&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <Icon.FileBarGraph />
                        </Link>
                </Nav.Item>
                <Nav.Item as="li">
                    <Link className="nav-link" role="button" to={`${match.url}/settings`}>
                        SETTINGS&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <Icon.Gear />
                        </Link>
                </Nav.Item>
            </Nav>
        </Nav>
    );
}

export default AdminSidebar;